module.exports = __webpack_public_path__ + "assets/img/space2.3a8101a1.jpg";